import React from "react";
import styles from "./index.module.scss";
import { useParams, useNavigate } from "react-router-dom";
export default function PaginationDot({ active, pageNum }) {
  const navigate = useNavigate();
  const { locale } = useParams();
  const handlePaging = () => {
    if (!active) {
      navigate(`/${locale}/projects?page_num=${pageNum}`);
    }
  };
  return (
    <span
      className={`${styles.dot} ${active ? styles.active : ""}`}
      onClick={handlePaging}
    >
      {pageNum}
    </span>
  );
}
